import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { MdSend as Ico } from 'react-icons/md';
// Components
import CommonButton from "../common/button/button";
import ModalConfirmYesNo from "../common/modalConfirmYesNo/modalConfirmYesNo";
// Actions
import * as pushNotificationsActions from "../../redux/actions/pushNotifications";
// Utils
import { getToastOpt } from "../../utils/utils";

const SendButton = ({ 
  id,
  setIsLoading,
  disabled,
  onSend,
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  // States
  const [modalConfirmData, setModalConfirmData] = useState({});

  let width = "120px";
  let marginLeft = "0px";

  const handleSend = async () => {
    setIsLoading(true);
    dispatch(pushNotificationsActions.send(id)).then(
      (response) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Notificació enviada`,
          status: "success",
          position: "top",
        }));
        onSend();
      },
      (err) => {
        setIsLoading(false);
        toast(getToastOpt({
          title: `Error enviant notificació`,
          description: err,
          status: "error",
        }));
      }
    );
  };

  return (
    <>
      <CommonButton
        onClick={() => {
          const title = 'Enviament a tots els usuaris';
          const description = `¿Estàs segur?`;
          setModalConfirmData({
            visible: true,
            title,
            description,
          });
        }}
        style={{
          width,
          marginLeft,
          display: "flex", // Use flexbox to control alignment
          alignItems: "center", // Center icon and text vertically
          justifyContent: "flex-start", // Align icon and text to the left
          gap: "8px", // Add spacing between icon and text
        }}
        disabled={disabled}
      >
        <Ico size={18} />
        <span>Enviar </span>
      </CommonButton>    
      {modalConfirmData.visible && (
        <ModalConfirmYesNo
          title={modalConfirmData.title}
          description={modalConfirmData.description}
          isOpen={modalConfirmData.visible}
          onClose={() => setModalConfirmData({})}
          handleClose={(confirm) => {
            if (confirm) {
              handleSend();
            }
            setModalConfirmData({});
          }}
        />
      )}
    </>
  );
};

export default SendButton;
